// GrpcService.js

import { AccountServiceClient } from '@/common/api/services/account/account_grpc_web_pb';
import { VoipServiceClient } from '@/common/api/services/voip/voip_grpc_web_pb';
import { AiServiceClient } from '@/common/api/services/ai/ai_grpc_web_pb';
import { PostServiceClient } from '@/common/api/services/post/post_grpc_web_pb';
import GrpcWebErrorHandler from '@/common/ErrorHandler';
import { convertProtoToJSON, refreshToken, getBaseUrl } from '@/common/utils';
import store from "@/store";

class GrpcService {
  /**
  * @param serviceType
  * 
  * @return { Object } The client for the requested service type. Note that this is an object with a constructor and can be used to create other services
  */
  createClient(serviceType) {
    // Returns a client for the given service type.
    switch (serviceType) {
      case 'account':
        return new AccountServiceClient(`${getBaseUrl("account")}`, null, null);
      case 'voip':
        return new VoipServiceClient(`${getBaseUrl("voip")}`, null, null);
      case 'ai':
        return new AiServiceClient(`${getBaseUrl("ai")}`, null, null);
      case 'post':
        return new PostServiceClient(`${getBaseUrl("post")}`, null, null);
      // Add more cases for other service types as needed
      default:
        throw new Error(`Unsupported service type: ${serviceType}`);
    }
  }

  /**
  * @param serviceType
  * @param method
  * @param requestData
  * @param metadata
  * 
  * @return { Promise } A promise that resolves with the response or rejects with an error message if there was an error
  */
  sendRequest(serviceType, method, requestData, metadata, timeoutSeconds = null) {
    const client = this.createClient(serviceType);
    if (timeoutSeconds) {
      const deadline = new Date();
      deadline.setSeconds(deadline.getSeconds() + timeoutSeconds);
      metadata = { ...metadata, deadline: deadline.getTime().toString() };
    }
    return new Promise((resolve, reject) => {
      client[method](requestData, metadata, (error, response) => {
        // If an error occurs while attempting to refresh the token.
        if (error) {
          const error_data = GrpcWebErrorHandler.handleGrpcWebError(error);
          const to_refresh_token_errors = [1012, 1013]
          const to_logout_errors = [1061, 1034]

          if (to_refresh_token_errors.includes(error_data.code)) {
            refreshToken(metadata).then(r => window.location.reload()).catch(err => {
              store.commit('setAccessToken', null);
              store.commit('setRefreshToken', null)
              window.location.reload();
            });
          } else if (to_logout_errors.includes(error_data.code)) {
            store.commit('setAccessToken', null);
            store.commit('setRefreshToken', null);
            store.commit('setTotpSecret', null)
            window.location.reload();
          }
          else {
            reject(error_data);
          }
        } else {
          resolve(convertProtoToJSON(response));
        }
      });
    });
  }
}

export default new GrpcService();
